/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import { Box, Text } from '@mantine/core';
import classes from './TableSites.module.css';
import clsx from 'clsx';
import { truncateString, uuid } from '@utils/functions';
import { Tooltip } from '@components/atoms/Tooltip';
import { useTranslation } from 'react-i18next';
import { TSite } from '@global-types/index';

/* -------------------------------------------------------------------------- */
/*                                     Type                                   */
/* -------------------------------------------------------------------------- */
type TSiteRow =
	| {
			name: string;
			minExpected: number;
			maxExpected: number;
			meterPointCount: number;
	  }
	| TSite;

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const TableSites = (props: {
	rows: Partial<TSiteRow[]>;
}) => {
	const { t } = useTranslation();
	return (
		<Box className={classes.table}>
			<Box className={classes.header}>
				<Box className={classes.cell}>
					<Text className={classes.title}>
						{t('global.name')}
					</Text>
				</Box>
				<Box
					className={clsx(
						classes.cell,
						classes.cellCenter
					)}
				>
					<Text className={classes.title}>
						{t('global.minExpected')}
					</Text>
				</Box>
				<Box
					className={clsx(
						classes.cell,
						classes.cellCenter
					)}
				>
					<Text className={classes.title}>
						{t('global.maxExpected')}
					</Text>
				</Box>
				<Box
					className={clsx(classes.cell, classes.cellEnd)}
				>
					<Text
						className={clsx(
							classes.title,
							classes.titleEnd
						)}
					>
						{t('global.meterPointCount')}
					</Text>
				</Box>
			</Box>
			{props.rows &&
				Array.isArray(props.rows) &&
				props.rows.map((item: any) => (
					<Box key={uuid()} className={classes.row}>
						<Tooltip
							isActive={
								item.name && item.name.length > 14
							}
							label={item && item.name ? item.name : ''}
						>
							<Box className={classes.cell}>
								<Text className={classes.value}>
									{truncateString(item.name, 14)}
								</Text>
							</Box>
						</Tooltip>
						<Box
							className={clsx(
								classes.cell,
								classes.cellCenter
							)}
						>
							<Text className={classes.value}>
								{item.minExpected}
							</Text>
						</Box>
						<Box
							className={clsx(
								classes.cell,
								classes.cellCenter
							)}
						>
							<Text className={classes.value}>
								{item.maxExpected}
							</Text>
						</Box>
						<Box
							className={clsx(
								classes.cell,
								classes.cellEnd
							)}
						>
							<Text className={classes.value}>
								{item.meterPointsCount}
							</Text>
						</Box>
					</Box>
				))}
		</Box>
	);
};
